// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionContent_root__1FxyJ","should-scroll":"SectionContent_should-scroll__3dKfI","should-debug-layout":"SectionContent_should-debug-layout__LG4ti"};